  /*global angular*/
  'use strict';

  var seo_data = {
    'home' : {
      'title_tag': 'Mr D Food | Delivered Fast And Hot across SA!',
      'description_tag': 'Get FREE delivery on your first app order. With over 2500 restaurants on the app we\'ve got whatever you feel like. We deliver to over 1900 suburbs across SA.'
    },
    'become-a-restaurant-partner' : {
      'title_tag': 'Mr D Food | Become a Restaurant Partner',
      'description_tag': 'Want to increase your restaurant\'s sales without the hassle of managing drivers? Partner with us & reach more customers than ever.'
    },
    'become-a-driver' : {
      'title_tag': 'Mr D Food | Become A Driver',
      'description_tag': 'Earn up to R75 per hour on a flexible schedule. Mr D drivers do a variety of deliveries delivering food, parcels and credit cards.'
    },
    'faq' : {
      'title_tag': 'Mr D Food | Frequently Asked Questions',
      'description_tag': 'Check out our FAQ\'s for answers to commonly asked questions. How do I sign up? How do I download the app? How do I place an order?'
    },
    'terms' : {
      'title_tag': 'Mr D Food | Terms & Conditions',
      'description_tag': 'Check out our T&C\'s to understand the legal terms that apply when you use mrdfood.com'
    },
    'contact' : {
      'title_tag': 'Mr D Food | Contact Us',
      'description_tag': 'To get in touch with us, visit our contact us page.'
    },
    'careers' : {
      'title_tag': 'Mr D Food | Careers',
      'description_tag': 'Join our fast growing team, and work on SA\'s largest food delivery platform'
    },
    'press' : {
      'title_tag': 'Mr D Food | Press',
      'description_tag': 'Check out our latest ads, press releases and articles where we have been featured.'
    },
    'mr-delivery-is-now-mr-d-food': {
      'title_tag' : 'Food Delivery | Order online | Mr D Food',
      'description_tag' : 'About Mr D Food - South Africa\'s Favourite Delivery Service!'
    },
    'login' : {
      'title_tag': 'Mr D Food | Login',
      'description_tag': 'Login to Mrdfood.com using your email and password to get food delivered fast and hot to your door!'
    },
    'register' : {
      'title_tag': 'Mr D Food | Register',
      'description_tag': 'Register with your email & get FREE delivery on your first app order.'
    },
    'sitemap': {
      'title_tag' : 'Mr D Food | Sitemap',
      'description_tag' : 'Home | FAQ | Terms | Login | Forgot Passwrod | Register | Become a Driver | Become a Restaurant Partner | Careers | Press | Contact Us | Sitemap'
    },
    'forgot' : {
      'title_tag' : 'Mr D Food | Forgot Password',
      'description_tag' : 'Forgetten your password? Just enter your email address you used to register and we will send you an email with instructions to reset your password.'
    },
    'comp_freefood' : {
      'title_tag' : 'Win R10 000 worth of free food, delivered by Mr D Food',
      'description_tag' : 'Order food and stand a chance to win R10000 worth of free food. Take part in the competition form Mr D Food, SA’s favourite food delivery app!',
      'keywords_tag' : 'Win, food, free, competition, delivery, order now'
    },
    'location': {
      'title_tag' : 'Restaurant Selection'
    },
    'cart' : {
      'title_tag': 'Your Cart'
    },
    'checkout': {
      'title_tag': 'Review & Checkout'
    },
    'payment_return' : {
      'title_tag': 'Placing Order...'
    },
    'payment_confirm' : {
      'title_tag': 'Confirm Order'
    },
    'history' : {
      'title_tag': 'Order History'
    },
    'tracking' : {
      'title_tag': 'Tracking Order'
    },
    'details' : {
      'title_tag': 'Order Details'
    },
    'exceptions' : {
      'title_tag': 'Order Failed'
    },
    'profile': {
      'title_tag' : 'Edit Profile'
    },
    'account': {
      'title_tag' : 'Edit Account'
    },
    'default': {
      'title_tag': 'Mr D Food | Delivered Fast And Hot!',
      'description_tag': 'Get FREE delivery on your first app order. With over 2500 restaurants on the app we\'ve got whatever you feel like. We deliver to over 1900 suburbs across SA. No card? Pay with cash on delivery!',
      'keywords_tag' : 'food, restaurant, delivery, ordering, take-aways, app, application, online, south africa, mr delivery'
    }
  };

  angular.module('MrDWebApp.seo', [])
  .factory('SEO', function(){
    return {
      titleTag : function(state){

        if(seo_data[state] && seo_data[state].title_tag){
          return seo_data[state].title_tag;
        }

        return seo_data.default.title_tag;

      },
      descriptionTag : function(state){

        if(seo_data[state] && seo_data[state].description_tag){
          return seo_data[state].description_tag;
        }

        return seo_data.default.description_tag;

      },
      keywordsTag : function(state){
        if(seo_data[state] && seo_data[state].keywords_tag){
          return seo_data[state].keywords_tag;
        }
        return seo_data.default.keywords_tag;

      }
    };
  });
